import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import "../../css/FilterModal.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { toast } from "../../components/Toast/toast.ts";

const styles = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "92%",
    sm: 430,
  },

  borderRadius: "8px",

  background: "rgb(var(--surface-1))",

  border: "1px solid rgb(var(--border-primary))",

  boxShadow: "var(--shadow-card-hover)",

  overflow: "hidden",

  outline: "none",

  backdropFilter: "blur(18px)",
};

export default function FilterModal({
  setLoading,
  setIsAllDataFetched,
  setCurrentCount,
  fetchCashierReports,
  setFilterVal,
  fetchfilteredData,
  fromdate,
  setFromdate,
  todate,
  setTodate,
}: any) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleFromDateChange = (newValue: any) => {
    setFromdate(newValue);

    if (newValue && todate && moment(newValue).isAfter(todate)) {
      setTodate(null);
    }
  };

  const handleToDateChange = (newValue: any) => {
    setTodate(newValue);

    if (newValue && fromdate && moment(fromdate).isAfter(newValue)) {
      setFromdate(null);
    }
  };

  const ResetFilter = async () => {
    try {
      setIsAllDataFetched(false);
      setCurrentCount(20);
      setLoading(true);

      setFromdate(null);
      setTodate(null);

      setFilterVal(false);

      fetchCashierReports();
    } catch (error) {
      toast.error("Unable to retrieve reports data!");
    }
  };

  return (
    <>
      {/* Trigger Button */}

      <Tooltip title="Filter By Date" arrow>
        <button
          onClick={handleOpen}
          className="
            flex
            items-center
            justify-center
            w-9
            h-9
            rounded-md
            transition-all
            duration-300
            border
            hover:scale-[1.03]
            active:scale-[0.98]
          "
          style={{
            background: "rgb(var(--surface-3))",
            borderColor: "rgb(var(--border-primary))",
            color: "rgb(var(--text-secondary))",
            boxShadow: "var(--shadow-sm)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor =
              "rgba(var(--color-gold-1),0.35)";

            e.currentTarget.style.background =
              "rgba(var(--color-gold-1),0.08)";

            e.currentTarget.style.color =
              "rgb(var(--color-gold-1))";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor =
              "rgb(var(--border-primary))";

            e.currentTarget.style.background =
              "rgb(var(--surface-2))";

            e.currentTarget.style.color =
              "rgb(var(--text-secondary))";
          }}
        >
          <CalendarMonthIcon fontSize="small" />
        </button>
      </Tooltip>

      {/* Modal */}

      <Modal open={open} onClose={handleClose}>
        <Box sx={styles}>
          {/* Header */}

          <div
            className="
              flex
              items-center
              justify-between
              px-6
              py-5
            "
            style={{
              background:
                "linear-gradient(180deg, rgba(var(--color-gold-1),0.08) 0%, transparent 100%)",

              borderBottom:
                "1px solid rgb(var(--border-primary))",
            }}
          >
            <div className="flex flex-col">
              <span
                className="
                  text-[18px]
                  font-semibold
                  tracking-tight
                "
                style={{
                  color: "rgb(var(--text-primary))",
                }}
              >
                Filter Reports
              </span>

              <span
                className="text-[12px] mt-1"
                style={{
                  color: "rgb(var(--text-muted))",
                }}
              >
                Select a date range to narrow results
              </span>
            </div>

            <div
              className="
                flex
                items-center
                justify-center
                w-11
                h-11
                rounded-2xl
              "
              style={{
                background:
                  "rgba(var(--color-gold-1),0.12)",

                border:
                  "1px solid rgba(var(--color-gold-1),0.18)",
              }}
            >
              <CalendarMonthIcon
                sx={{
                  color: "rgb(var(--color-gold-1))",
                  fontSize: 20,
                }}
              />
            </div>
          </div>

          {/* Body */}

          <div className="p-6">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-2">
                  <span
                    className="text-[12px] font-medium uppercase tracking-[0.08em]"
                    style={{
                      color: "rgb(var(--text-muted))",
                    }}
                  >
                    From Date
                  </span>

                  <DatePicker
                    disableFuture
                    value={fromdate}
                    onChange={handleFromDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "52px",

                        borderRadius: "6px",

                        background:
                          "rgb(var(--surface-2))",

                        color:
                          "rgb(var(--text-primary))",

                        transition: "all 0.25s ease",
                      },

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor:
                          "rgb(var(--border-primary))",
                      },

                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor:
                          "rgba(var(--color-gold-1),0.35)",
                      },

                      "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor:
                            "rgba(var(--color-gold-1),0.45)",
                        },

                      "& .MuiInputLabel-root": {
                        color:
                          "rgb(var(--text-muted))",
                      },

                      "& .MuiInputBase-input": {
                        color:
                          "rgb(var(--text-primary))",
                        fontSize: "14px",
                      },

                      "& .MuiSvgIcon-root": {
                        color:
                          "rgb(var(--text-secondary))",
                      },
                    }}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <span
                    className="text-[12px] font-medium uppercase tracking-[0.08em]"
                    style={{
                      color: "rgb(var(--text-muted))",
                    }}
                  >
                    To Date
                  </span>

                  <DatePicker
                    disableFuture
                    value={todate}
                    disabled={!fromdate}
                    minDate={fromdate}
                    onChange={handleToDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "52px",

                        borderRadius: "6px",

                        background:
                          "rgb(var(--surface-2))",

                        color:
                          "rgb(var(--text-primary))",
                      },

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor:
                          "rgb(var(--border-primary))",
                      },

                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor:
                          "rgba(var(--color-gold-1),0.35)",
                      },

                      "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor:
                            "rgba(var(--color-gold-1),0.45)",
                        },

                      "& .MuiInputLabel-root": {
                        color:
                          "rgb(var(--text-muted))",
                      },

                      "& .MuiInputBase-input": {
                        color:
                          "rgb(var(--text-primary))",
                        fontSize: "14px",
                      },

                      "& .MuiSvgIcon-root": {
                        color:
                          "rgb(var(--text-secondary))",
                      },
                    }}
                  />
                </div>
              </div>

              {/* Info Box */}

              {(fromdate || todate) && (
                <div
                  className="
                    mt-5
                    px-4
                    py-3
                    rounded-2xl
                    flex
                    items-center
                    justify-between
                  "
                  style={{
                    background:
                      "rgba(var(--color-gold-1),0.08)",

                    border:
                      "1px solid rgba(var(--color-gold-1),0.15)",
                  }}
                >
                  <div className="flex flex-col">
                    <span
                      className="text-[11px] uppercase tracking-[0.08em]"
                      style={{
                        color:
                          "rgb(var(--text-muted))",
                      }}
                    >
                      Selected Range
                    </span>

                    <span
                      className="text-[13px] font-medium mt-1"
                      style={{
                        color:
                          "rgb(var(--text-primary))",
                      }}
                    >
                      {fromdate
                        ? moment(fromdate).format(
                            "DD MMM YYYY"
                          )
                        : "--"}{" "}
                      →{" "}
                      {todate
                        ? moment(todate).format(
                            "DD MMM YYYY"
                          )
                        : "--"}
                    </span>
                  </div>
                </div>
              )}

              {/* Buttons */}

              <Stack
                direction="row"
                spacing={1.5}
                sx={{
                  marginTop: "28px",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<RestartAltRoundedIcon />}
                  onClick={() => {
                    ResetFilter();
                    handleClose();
                  }}
                  sx={{
                    height: "36px",

                    borderRadius: "6px",

                    textTransform: "none",

                    fontWeight: 600,

                    paddingInline: "18px",

                    background:
                      "rgb(var(--surface-2))",

                    color:
                      "rgb(var(--text-primary))",

                    border:
                      "1px solid rgb(var(--border-primary))",

                    boxShadow: "none",

                    "&:hover": {
                      background:
                        "rgba(239,68,68,0.08)",

                      borderColor:
                        "rgba(239,68,68,0.25)",

                      color: "#ef4444",

                      boxShadow: "none",
                    },
                  }}
                >
                  Reset
                </Button>

                <Button
                  variant="contained"
                  startIcon={<CheckRoundedIcon />}
                  onClick={() => {
                    fetchfilteredData();
                    handleClose();
                  }}
                  disabled={!todate && !fromdate}
                  sx={{
                    height: "36px",

                    borderRadius: "6px",

                    textTransform: "none",

                    fontWeight: 600,

                    paddingInline: "22px",

                    background:
                      "var(--gold-grad)",

                    color: "#fff",

                    boxShadow: "none",

                    "&:hover": {
                      background:
                        "rgba(var(--color-gold-2))",

                      boxShadow:
                        "0 10px 30px rgba(var(--color-gold-1),0.25)",
                    },
                  }}
                >
                  Apply Filter
                </Button>
              </Stack>
            </LocalizationProvider>
          </div>
        </Box>
      </Modal>
    </>
  );
}